// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-filter-field {
   font-size: 14px;
   width: auto;
   margin-left: 4px;
}

/* Strip the modern outlined box (border + background) so this reads like the rest of the
   app's plain inline selects — just the value text and a small caret, no visible field box. */
.task-filter-field ::ng-deep .mdc-notched-outline {
   display: none;
}

.task-filter-field ::ng-deep .mat-mdc-text-field-wrapper {
   padding: 0;
   background: transparent;
   border-bottom: 1px solid rgba(0, 0, 0, 0.42);
}

.task-filter-field ::ng-deep .mat-mdc-form-field-flex {
   align-items: center;
}

.task-filter-field ::ng-deep .mat-mdc-form-field-infix {
   min-height: 0;
   padding: 0 0 4px;
   width: auto;
}

/* Match the plain "Date Range:" / "Group by:" label text exactly — Material's own MDC
   typography styles were overriding the 14px set on the host above and using a slightly
   different text color. */
.task-filter-field ::ng-deep .mat-mdc-select-value {
   font-size: 14px;
   color: rgba(0, 0, 0, 0.87);
}

.task-filter-field ::ng-deep .mat-mdc-select-arrow {
   color: rgba(0, 0, 0, 0.87);
}

/* Stripping the field's own padding above also zeroed the gap the arrow wrapper normally
   gets from it, so the caret ends up glued to the value text — add it back directly. */
.task-filter-field ::ng-deep .mat-mdc-select-arrow-wrapper {
   margin-left: 4px;
}

/* The dropdown panel (mat-option rows) renders into the CDK overlay, outside this component's
   own DOM subtree, so it can't be reached through \`.task-filter-field\` — panelClass scopes
   this instead. Match the trigger's 14px so opened options read the same size as the closed
   value and the "Date Range:" / "Group by:" label next to it. */
::ng-deep .task-filter-panel .mat-mdc-option {
   font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/task-filter-select/task-filter-select.component.css"],"names":[],"mappings":"AAAA;GACG,eAAe;GACf,WAAW;GACX,gBAAgB;AACnB;;AAEA;8FAC8F;AAC9F;GACG,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,uBAAuB;GACvB,4CAA4C;AAC/C;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,WAAW;AACd;;AAEA;;0BAE0B;AAC1B;GACG,eAAe;GACf,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;uFACuF;AACvF;GACG,gBAAgB;AACnB;;AAEA;;;gEAGgE;AAChE;GACG,eAAe;AAClB","sourcesContent":[".task-filter-field {\n   font-size: 14px;\n   width: auto;\n   margin-left: 4px;\n}\n\n/* Strip the modern outlined box (border + background) so this reads like the rest of the\n   app's plain inline selects — just the value text and a small caret, no visible field box. */\n.task-filter-field ::ng-deep .mdc-notched-outline {\n   display: none;\n}\n\n.task-filter-field ::ng-deep .mat-mdc-text-field-wrapper {\n   padding: 0;\n   background: transparent;\n   border-bottom: 1px solid rgba(0, 0, 0, 0.42);\n}\n\n.task-filter-field ::ng-deep .mat-mdc-form-field-flex {\n   align-items: center;\n}\n\n.task-filter-field ::ng-deep .mat-mdc-form-field-infix {\n   min-height: 0;\n   padding: 0 0 4px;\n   width: auto;\n}\n\n/* Match the plain \"Date Range:\" / \"Group by:\" label text exactly — Material's own MDC\n   typography styles were overriding the 14px set on the host above and using a slightly\n   different text color. */\n.task-filter-field ::ng-deep .mat-mdc-select-value {\n   font-size: 14px;\n   color: rgba(0, 0, 0, 0.87);\n}\n\n.task-filter-field ::ng-deep .mat-mdc-select-arrow {\n   color: rgba(0, 0, 0, 0.87);\n}\n\n/* Stripping the field's own padding above also zeroed the gap the arrow wrapper normally\n   gets from it, so the caret ends up glued to the value text — add it back directly. */\n.task-filter-field ::ng-deep .mat-mdc-select-arrow-wrapper {\n   margin-left: 4px;\n}\n\n/* The dropdown panel (mat-option rows) renders into the CDK overlay, outside this component's\n   own DOM subtree, so it can't be reached through `.task-filter-field` — panelClass scopes\n   this instead. Match the trigger's 14px so opened options read the same size as the closed\n   value and the \"Date Range:\" / \"Group by:\" label next to it. */\n::ng-deep .task-filter-panel .mat-mdc-option {\n   font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
